import { BehaviorSubject, Observable, firstValueFrom } from 'rxjs';
import { StorageMap } from '@ngx-pwa/local-storage';

export class SelectionServiceBase<T> {
  public selectionSubject: BehaviorSubject<T | null> = new BehaviorSubject<T | null>(null);
  public selection$: Observable<T | null> = this.selectionSubject.asObservable();

  constructor(
    private storage: StorageMap,
    private storageKey: string
  ) {
    // Load stored value asynchronously on init
    this.storage.get(this.storageKey).subscribe(stored => {
      const parsed = stored ? (stored as T) : null;
      this.selectionSubject.next(parsed);
    });
  }

  setSelected(value: T, storeValue: boolean = false): void {
    this.selectionSubject.next(value);
    if (storeValue) {
      this.storage.set(this.storageKey, value).subscribe();
    }
  }

  getSelected(): T | null {
    return this.selectionSubject.getValue();
  }

  async getStoredSelection(): Promise<T | null> {
    const value = await firstValueFrom(this.storage.get(this.storageKey));
    return value ? (value as T) : null;
  }

  clearSelected(): void {
    this.selectionSubject.next(null);
    this.storage.delete(this.storageKey).subscribe();
  }
}
